import React from "react";
import Breadcrumbs from "../../components/Breadcrumbs/Breadcrumbs";
import "./termsAndConditions.css";
import ProgressBarLoader from "../../components/ProgressBarLoader/ProgressBarLoader";

const Section = ({ number, title, children, featured = false }) => (
  <details
    className={`terms-accordion ${
      featured ? "terms-accordion--featured" : ""
    }`}
  >
    <summary>
      <div className="terms-summary-left">
        <span className="terms-number">
          {String(number).padStart(2, "0")}
        </span>

        <span className="terms-summary-title">{title}</span>
      </div>

      <span className="terms-chevron" aria-hidden="true">
        +
      </span>
    </summary>

    <div className="terms-accordion-content">{children}</div>
  </details>
);

const BulletList = ({ items }) => (
  <ul className="terms-list">
    {items.map((item, index) => (
      <li key={index}>{item}</li>
    ))}
  </ul>
);

const TermsAndConditions = () => {
  return (
    <div className="terms-page">
      <ProgressBarLoader />

      <Breadcrumbs
        title="Términos y Condiciones"
        pagename="Términos y Condiciones"
      />

      <main className="container py-5">
        {/* HERO */}
        <div className="terms-updated">
              <span className="terms-updated-dot"></span>
              Última actualización: 22 de septiembre de 2026
            </div>

        {/* AVISO SUPERIOR */}
        <section className="terms-notice">
          <div className="terms-notice-icon">
            !
          </div>

          <div>
            <strong>Importante</strong>
            <p>
              Al realizar una compra o utilizar nuestros servicios,
              manifiestas haber leído y aceptado los presentes Términos y
              Condiciones.
            </p>
          </div>
        </section>

        {/* ACCORDIONS */}
        <section className="terms-sections">

          {/* 01 */}
          <Section number={1} title="Datos del prestador del servicio">
            <p>
              Los servicios ofrecidos a través de
              <strong> salinacrucenses.com</strong> son prestados por:
            </p>

            <div className="company-card">
              <div className="company-card-header">
                <div className="company-logo-placeholder">
                  GV
                </div>

                <div>
                  <h3>GRUPO VIALA</h3>
                  <span>Prestador del servicio</span>
                </div>
              </div>

              <div className="company-data">
                <div>
                  <span>Razón social</span>
                  <strong>GRUPO VIALA</strong>
                </div>

                <div>
                  <span>RFC</span>
                  <strong>GVI1202145L0</strong>
                </div>

                <div>
                  <span>Régimen</span>
                  <strong>
                    Sociedad Cooperativa de Responsabilidad Limitada de
                    Capital Variable
                  </strong>
                </div>

                <div>
                  <span>Domicilio registrado</span>
                  <strong>
                    Calle Luis Echeverría, S/N, Col. Deportiva,
                    C.P. 70612, Salina Cruz, Oaxaca.
                  </strong>
                </div>
              </div>
            </div>
          </Section>

          {/* 02 */}
          <Section number={2} title="Compra de boletos">
            <p>
              Los boletos adquiridos a través de
              <strong> salinacrucenses.com</strong> están sujetos a
              disponibilidad de horarios, corridas y asientos.
            </p>

            <p>
              El boleto adquirido será válido únicamente para los datos
              indicados en el mismo.
            </p>

            <BulletList
              items={[
                "Pasajero indicado en el boleto.",
                "Origen señalado.",
                "Destino señalado.",
                "Fecha indicada.",
                "Horario indicado.",
                "Servicio contratado."
              ]}
            />

            <p>
              El usuario deberá revisar cuidadosamente la información
              antes de concluir su compra.
            </p>
          </Section>

          {/* 03 */}
          <Section number={3} title="Boleto y abordaje">
            <p>
              El pasajero deberá presentarse con anticipación suficiente
              para abordar la unidad.
            </p>

            <p>
              El boleto deberá conservarse durante todo el viaje y podrá
              ser solicitado por el personal autorizado.
            </p>

            <p>
              Los boletos electrónicos podrán presentarse desde un
              dispositivo móvil o en formato impreso, siempre que sean
              legibles.
            </p>

            <p>
              La hora indicada en el boleto corresponde al horario
              programado de salida.
            </p>

            <div className="terms-info-box">
              <strong>Importante</strong>
              <p>
                Los tiempos de llegada pueden variar debido a condiciones
                de tránsito, clima, situaciones operativas o circunstancias
                ajenas a la empresa.
              </p>
            </div>
          </Section>

          {/* 04 */}
          <Section
            number={4}
            title="Cancelación de boletos"
            featured
          >
            <div className="terms-rule-highlight">
              <span className="terms-rule-number">1 HORA</span>
              <span>
                antes de la hora programada de salida
              </span>
            </div>

            <p>
              Las solicitudes de cancelación deberán realizarse como
              máximo <strong>1 hora antes</strong> de la hora programada
              de salida de la unidad.
            </p>

            <p>
              Una vez transcurrido dicho plazo, el boleto no podrá ser
              cancelado bajo esta política.
            </p>
          </Section>

          {/* 05 */}
          <Section
            number={5}
            title="Transferencia de boletos"
            featured
          >
            <div className="terms-rule-highlight">
              <span className="terms-rule-number">40 MIN</span>
              <span>
                antes de la hora programada de salida
              </span>
            </div>

            <p>
              La transferencia de un boleto a otra fecha u horario deberá
              solicitarse como máximo <strong>40 minutos antes</strong>
              de la hora programada de salida.
            </p>

            <p>
              Las compras realizadas en línea, mediante transferencia
              bancaria o con tarjetas de crédito o débito
              <strong> no son reembolsables.</strong>
            </p>

            <p>
              Cuando las condiciones del boleto lo permitan, el usuario
              podrá solicitar la transferencia a otra fecha u horario,
              siempre sujeta a disponibilidad.
            </p>
          </Section>

          {/* 06 */}
          <Section
            number={6}
            title="Modificación de asientos"
            featured
          >
            <div className="terms-rule-highlight">
              <span className="terms-rule-number">20 MIN</span>
              <span>
                antes de la hora programada de salida
              </span>
            </div>

            <p>
              Las modificaciones de asiento podrán solicitarse hasta
              <strong> 20 minutos antes</strong> de la hora programada
              de salida.
            </p>

            <p>
              Toda modificación estará sujeta a la disponibilidad de
              asientos al momento de realizar la solicitud.
            </p>

            <p>
              Una vez transcurrido dicho plazo, no se garantiza la
              posibilidad de realizar modificaciones.
            </p>
          </Section>

          {/* 07 */}
          <Section number={7} title="Cambio de nombre del pasajero">
            <div className="terms-danger-box">
              <span className="terms-danger-icon">×</span>

              <div>
                <strong>No está permitido el cambio de nombre</strong>

                <p>
                  Los boletos adquiridos no podrán modificarse para
                  sustituir el nombre del pasajero.
                </p>
              </div>
            </div>

            <p>
              La transferencia de fecha u horario no implica un cambio de
              identidad del pasajero.
            </p>
          </Section>

          {/* 08 */}
          <Section number={8} title="Pasajero que no aborda">
            <p>
              En caso de que el pasajero no se presente a tiempo y la
              unidad haya salido conforme al horario establecido en su
              boleto, el boleto se considerará como no utilizado.
            </p>

            <p>
              Cuando la unidad ya haya salido,
              <strong> no procederá el reembolso.</strong>
            </p>

            <div className="terms-discount-box">
              <span className="discount-percent">50%</span>

              <div>
                <strong>Beneficio para una próxima salida</strong>

                <p>
                  Podrá ofrecerse un descuento del 50% sobre el costo de
                  una próxima salida, siempre que sea el mismo día,
                  exista disponibilidad y se cumplan las condiciones
                  operativas establecidas.
                </p>
              </div>
            </div>
          </Section>

          {/* 09 */}
          <Section number={9} title="Formas de pago">
            <p>
              Los medios de pago disponibles serán los que aparezcan
              habilitados al momento de realizar la compra.
            </p>

            <BulletList
              items={[
                "Tarjetas de crédito.",
                "Tarjetas de débito.",
                "Transferencia bancaria.",
                "Compra en línea."
              ]}
            />

            <div className="terms-info-box">
              <strong>Pagos en línea</strong>
              <p>
                Los pagos realizados mediante los medios habilitados en
                la plataforma están sujetos a las condiciones de pago y
                cancelación establecidas en estos Términos y Condiciones.
              </p>
            </div>

            <p className="terms-small">
              Los pagos son procesados mediante Openpay.
            </p>
          </Section>

          {/* 10 */}
          <Section
            number={10}
            title="Facturación"
            featured
          >
            <div className="billing-card">
              <div className="billing-icon">
                $
              </div>

              <div>
                <span className="billing-label">
                  FACTURACIÓN EN LÍNEA
                </span>

                <h3>
                  Factura tu boleto directamente desde el portal
                </h3>

                <p>
                  Ingresa a <strong>salinacrucenses.com</strong> y
                  utiliza la sección <strong>Facturación</strong>.
                </p>
              </div>
            </div>

            <div className="terms-timeline">
              <div className="timeline-item">
                <span className="timeline-number">01</span>

                <div>
                  <strong>Salida de la unidad</strong>
                  <p>
                    El viaje debe realizarse conforme a la información
                    indicada en el boleto.
                  </p>
                </div>
              </div>

              <div className="timeline-item">
                <span className="timeline-number">02</span>

                <div>
                  <strong>15 minutos después</strong>
                  <p>
                    El boleto queda habilitado para facturación.
                  </p>
                </div>
              </div>

              <div className="timeline-item">
                <span className="timeline-number">03</span>

                <div>
                  <strong>Último día del mes</strong>
                  <p>
                    El usuario tiene como fecha límite el último día del
                    mes correspondiente a la fecha del viaje.
                  </p>
                </div>
              </div>
            </div>

            <div className="terms-info-box">
              <strong>Ejemplo</strong>

              <p>
                Si el viaje se realizó el 15 de septiembre, el boleto
                podrá facturarse a partir de 15 minutos después de la
                salida de la unidad y hasta el 30 de septiembre.
              </p>
            </div>

            <p>
              El usuario será responsable de proporcionar correctamente
              sus datos fiscales.
            </p>
          </Section>

          {/* 11 */}
          <Section number={11} title="Equipaje">
            <p>
              El pasajero podrá transportar equipaje conforme a las
              condiciones, límites y disposiciones establecidas por la
              empresa.
            </p>

            <p>
              El equipaje deberá estar correctamente cerrado, identificado
              y acondicionado para su transporte.
            </p>

            <p>
              La empresa podrá rechazar el transporte de objetos que
              representen un riesgo para los pasajeros, operadores,
              unidades o instalaciones.
            </p>
          </Section>

          {/* 12 */}
          <Section number={12} title="Objetos y sustancias prohibidas">
            <p>
              Por razones de seguridad, queda prohibido transportar o
              portar dentro de las unidades, equipaje o paquetería:
            </p>

            <BulletList
              items={[
                "Armas de cualquier tipo.",
                "Sustancias nocivas o peligrosas.",
                "Material inflamable.",
                "Explosivos.",
                "Sustancias que representen un riesgo para las personas o instalaciones.",
                "Cualquier otro objeto cuyo transporte esté prohibido por las disposiciones legales aplicables."
              ]}
            />

            <div className="terms-danger-box">
              <span className="terms-danger-icon">!</span>

              <div>
                <strong>Por seguridad de todos</strong>

                <p>
                  La empresa podrá negar el transporte de objetos cuando
                  existan razones de seguridad o cuando su traslado se
                  encuentre prohibido por la legislación aplicable.
                </p>
              </div>
            </div>
          </Section>

          {/* 13 */}
          <Section number={13} title="Paquetería">
            <p>
              El servicio de paquetería estará sujeto a disponibilidad y
              a las condiciones establecidas por la empresa.
            </p>

            <div className="package-grid">
              <div className="package-card">
                <span className="package-card-icon">⚖</span>
                <strong>Costo</strong>
                <p>
                  Se establece de acuerdo con el volumen, peso y
                  características del paquete.
                </p>
              </div>

              <div className="package-card">
                <span className="package-card-icon">30</span>
                <strong>Cancelación</strong>
                <p>
                  Hasta 30 minutos posteriores a la compra, sujeto al
                  horario de salida de la unidad.
                </p>
              </div>

              <div className="package-card">
                <span className="package-card-icon">15</span>
                <strong>Recolección</strong>
                <p>
                  El destinatario cuenta con 15 días para recoger su
                  paquete.
                </p>
              </div>
            </div>

            <p>
              El precio correspondiente será informado al usuario antes
              de realizar la contratación.
            </p>
          </Section>

          {/* 14 */}
          <Section number={14} title="Productos perecederos">
            <div className="terms-info-box">
              <strong>Requisito de empaque</strong>

              <p>
                Los productos perecederos deberán transportarse
                <strong> en hielera y correctamente sellados.</strong>
              </p>
            </div>

            <div className="terms-danger-box">
              <span className="terms-danger-icon">×</span>

              <div>
                <strong>No se permiten en bolsas</strong>

                <p>
                  Los productos perecederos deberán entregarse en las
                  condiciones de empaque indicadas para su transporte.
                </p>
              </div>
            </div>
          </Section>

          {/* 15 */}
          <Section number={15} title="Responsabilidad del remitente">
            <p>
              La persona que envíe un paquete será responsable de
              declarar correctamente su contenido y proporcionar la
              información necesaria para su transporte.
            </p>

            <p>
              No deberá entregar objetos o sustancias prohibidas,
              peligrosas o cuyo transporte esté restringido.
            </p>

            <p>
              La empresa podrá rechazar paquetes que no cumplan con las
              condiciones de seguridad o empaque requeridas.
            </p>
          </Section>

          {/* 16 */}
          <Section number={16} title="Información de horarios y corridas">
            <p>
              Los horarios publicados en el sitio web corresponden a la
              programación disponible al momento de la consulta o compra.
            </p>

            <p>
              Las situaciones de tránsito, clima, mantenimiento, cierres
              carreteros, accidentes, instrucciones de autoridades,
              emergencias u otras circunstancias ajenas al control directo
              de la empresa pueden ocasionar modificaciones en los horarios.
            </p>

            <p>
              La hora de salida indicada en el boleto será la referencia
              para efectos de las políticas de cancelación, transferencia
              y modificación de asiento.
            </p>
          </Section>

          {/* 17 */}
          <Section number={17} title="Disponibilidad de asientos">
            <p>
              La selección de asiento estará sujeta a la disponibilidad
              mostrada por el sistema al momento de la compra.
            </p>

            <p>
              La disponibilidad puede cambiar conforme otros usuarios
              realicen compras o modificaciones.
            </p>

            <p>
              La empresa podrá realizar cambios operativos de unidad o
              asignación de asiento cuando sea necesario por razones de
              operación o seguridad.
            </p>
          </Section>

          {/* 18 */}
          <Section number={18} title="Sitio web y compras en línea">
            <p>
              El usuario se compromete a utilizar el sitio web de manera
              lícita y únicamente para los fines relacionados con los
              servicios ofrecidos.
            </p>

            <p>Queda prohibido:</p>

            <BulletList
              items={[
                "Utilizar mecanismos automatizados para afectar el funcionamiento del sitio.",
                "Intentar acceder sin autorización a sistemas o información.",
                "Alterar información de boletos.",
                "Utilizar información de terceros sin autorización.",
                "Realizar operaciones fraudulentas.",
                "Interferir con la operación normal de la plataforma."
              ]}
            />
          </Section>

          {/* 19 */}
          <Section number={19} title="Datos personales">
            <p>
              Los datos personales proporcionados por los usuarios serán
              tratados conforme al Aviso de Privacidad de la empresa y a
              la legislación mexicana aplicable en materia de protección
              de datos personales.
            </p>

            <a
  href="https://salinacrucenses.com/politicas-de-privacidad"
  className="terms-link-button"
  target="_blank"
  rel="noopener noreferrer"
>
  Consultar Política de Privacidad
  <span>→</span>
</a>
          </Section>

          {/* 20 */}
          <Section number={20} title="Atención a clientes">
            <p>
              Para dudas, aclaraciones, modificaciones o solicitudes
              relacionadas con boletos, facturación o paquetería, el
              usuario podrá comunicarse a través de los medios de contacto
              publicados en el sitio web.
            </p>

            <div className="contact-card">
              <div className="contact-item">
                <span>WhatsApp / Teléfono</span>
                <strong>951 569 5305</strong>
              </div>

              <div className="contact-item">
                <span>Correo electrónico</span>
                <strong>soluciones@salinacrucenses.com</strong>
              </div>
            </div>

            <p className="terms-small">
              Para agilizar la atención, se recomienda proporcionar
              número de boleto, fecha de viaje, origen, destino y nombre
              del pasajero cuando corresponda.
            </p>
          </Section>

          {/* 21 */}
          <Section number={21} title="Actualización de los Términos y Condiciones">
            <p>
              La empresa podrá actualizar los presentes Términos y
              Condiciones cuando resulte necesario debido a cambios en
              sus servicios, procesos, operación o disposiciones legales
              aplicables.
            </p>

            <p>
              La versión vigente será aquella publicada en
              <strong> salinacrucenses.com</strong>.
            </p>
          </Section>

          {/* 22 */}
          <Section number={22} title="Legislación aplicable">
            <p>
              Los presentes Términos y Condiciones se interpretarán de
              conformidad con las disposiciones legales aplicables en los
              Estados Unidos Mexicanos.
            </p>

            <p>
              En materia de protección al consumidor se observará la
              legislación mexicana aplicable.
            </p>
          </Section>

          {/* 23 */}
          <Section number={23} title="Aceptación">
            <div className="acceptance-box">
              <span className="acceptance-check">✓</span>

              <div>
                <strong>Aceptación de los términos</strong>

                <p>
                  Al realizar una compra o utilizar los servicios
                  disponibles en <strong>salinacrucenses.com</strong>,
                  el usuario declara haber tenido acceso a los presentes
                  Términos y Condiciones y aceptar las disposiciones
                  aplicables al servicio contratado.
                </p>
              </div>
            </div>
          </Section>
        </section>

        {/* FOOTER */}
        <section className="terms-footer-card">
          <div>
            <span className="terms-footer-label">
              GRUPO VIALA
            </span>

            <h2>
              Gracias por viajar con nosotros.
            </h2>

            <p>
              Para cualquier duda sobre estas condiciones, nuestro equipo
              de atención está disponible para ayudarte.
            </p>
          </div>

          <a
            href="mailto:hola@salinacrucenses.com"
            className="terms-contact-button"
          >
            Contactar
            <span>→</span>
          </a>
        </section>

        
      </main>
    </div>
  );
};

export default TermsAndConditions;